export const vastTags = [
  // --- Linear ---
  {
    name: 'inline-linear',
    label: 'Inline Linear',
    category: 'Linear',
    description: 'Standard inline linear VAST ad (local)',
    url: '/vast-tags/inline-linear.xml',
    expectedBehavior: 'Linear video ad plays before content resumes',
  },
  {
    name: 'inline-linear-skippable',
    label: 'Skippable Linear',
    category: 'Linear',
    description: 'Skippable linear ad with 5s skip offset (local)',
    url: '/vast-tags/inline-linear-skippable.xml',
    expectedBehavior: 'Ad plays with skip button appearing after 5 seconds',
  },

  // --- Wrappers ---
  {
    name: 'wrapper-linear',
    label: 'Wrapper -> Linear',
    category: 'Wrapper',
    description: 'VAST wrapper that redirects to inline linear (local)',
    url: '/vast-tags/wrapper-linear.xml',
    expectedBehavior: 'Wrapper resolves to inline linear and plays',
  },

  // --- Non-Linear ---
  {
    name: 'inline-nonlinear',
    label: 'Inline Non-Linear',
    category: 'Non-Linear',
    description: 'Non-linear overlay ad (local)',
    url: '/vast-tags/inline-nonlinear.xml',
    expectedBehavior: 'Overlay displayed on top of playing content',
  },

  // --- Ad Pod ---
  {
    name: 'ad-pod',
    label: 'Ad Pod (2 ads)',
    category: 'Ad Pod',
    description: 'Two sequential ads in a pod (local)',
    url: '/vast-tags/ad-pod.xml',
    expectedBehavior: 'Two ads play back-to-back',
  },

  // --- Companion ---
  {
    name: 'companion-linear',
    label: 'Linear + Companion',
    category: 'Companion',
    description: 'Linear ad with a local multi-size companion suite',
    url: '/vast-tags/companion-linear.xml',
    expectedBehavior: 'Linear ad plays with companion ad available',
  },
];
